import styled from '@emotion/styled';

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    width: 100%;
`;

export const CommonRowWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
`;

export const FlexPageContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 2rem;
`;

export const SubSectionContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
    gap: 2rem;
    width: 100%;
    max-width: 775px;
    margin: 2rem auto;
`;

export const SubSectionContentStack = styled(SubSectionContent)`
    gap: 0;
`;

export const SubSectionDialogContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
    width: 100%;
    max-width: 775px;
    margin: 1rem auto;
    gap: 0.5rem;
`;

export const CenterRowWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    & > * {
        transition: all 0.2s ease-in-out;
    }
`;

export const SpaceBetweenWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    margin: 1rem 0;
`;

export const MenuRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
`;

export const ContentView = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-grow: 1;
    min-width: 0;
    padding: 0 0.5rem;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    width: 100%;
`;

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
`;

export const ContextRow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding: 0.375rem 0.25rem;
    min-width: 0;
`;

export const FlexEndRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;
    align-items: center;
    gap: 0.5rem;
`;
